export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9611.879f9be0.jpg";